import React, { useState, useEffect } from "react";
import { Button } from '../../ui/button';
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import {
  verifyKyc,
  getPlayer,
  getKycDoc,
  rejectKyc,
} from "./PrimaryPlayerSlice";
import { getDateTimeFormate } from "../../sharedfiles/helper";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../ui/dialog";
import { COMMON_CONSTANTS, KYC_CONSTANTS } from "../../sharedfiles/Constants";
import KycCommentBox from "../KycUsers/KycCommentBox";
import { useColumnPreferences } from "../../sharedfiles/hooks/useColumnPreferences";
import TableToolbar from "../Common/table/TableToolbar";

// Identity Docs and Address Docs render the same table shape (just a
// different data source and storage key) - shared here so both stay in
// sync and each gets its own independent column preferences.
const KycDocsTable = ({ docs, kycPermission, storageKey, onView, onConfirm, onReject }) => {
  const headers = [
    KYC_CONSTANTS.header_id,
    ...(kycPermission ? [KYC_CONSTANTS.header_documentId] : []),
    ...(kycPermission ? [COMMON_CONSTANTS.header_name] : []),
    ...(kycPermission ? [COMMON_CONSTANTS.header_firstname] : []),
    ...(kycPermission ? [COMMON_CONSTANTS.header_lastname] : []),
    ...(kycPermission ? [KYC_CONSTANTS.header_dob] : []),
    KYC_CONSTANTS.header_status,
    COMMON_CONSTANTS.updatedDate,
    KYC_CONSTANTS.header_docs,
    KYC_CONSTANTS.header_action,
  ];
  const rowAccessors = [
    (item) => item.id,
    ...(kycPermission ? [(item) => item.docId] : []),
    ...(kycPermission ? [(item) => `${item.firstName === null ? "" : item.firstName} ${item.lastName === null ? "" : item.lastName}`] : []),
    ...(kycPermission ? [(item) => item.firstName] : []),
    ...(kycPermission ? [(item) => item.lastName] : []),
    ...(kycPermission ? [(item) => item.dob] : []),
    (item) => (
      <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
        item.docStatus === "KYC_PASSED" ? "bg-green-100 text-green-800" :
        item.docStatus === "REJECTED" ? "bg-red-100 text-red-800" :
        "bg-yellow-100 text-yellow-800"
      }`}>
        {item.docStatus}
      </span>
    ),
    (item) => getDateTimeFormate(item.updatedDate),
    (item) => (
      <Button
        onClick={() => onView(item.docPath)}
        variant="default"
        size="sm"
        className="h-8"
      >
        {KYC_CONSTANTS.viewDoc_btn}
      </Button>
    ),
    (item) =>
      item.docStatus !== "KYC_PASSED" && item.docStatus !== "REJECTED" && (
        <div className="flex flex-col gap-1">
          <Button
            onClick={() => onConfirm(item.id)}
            variant="default"
            size="sm"
            className="h-8"
            disabled={!kycPermission}
          >
            {KYC_CONSTANTS.header_confirm}
          </Button>
          <Button
            onClick={() => onReject(item.id)}
            variant="destructive"
            size="sm"
            className="h-8"
            disabled={!kycPermission}
          >
            {KYC_CONSTANTS.header_reject}
          </Button>
        </div>
      ),
  ];
  const cellClassName = [
    "px-4 py-3 text-sm text-foreground",
    ...(kycPermission ? ["px-4 py-3 text-sm text-foreground"] : []),
    ...(kycPermission ? ["px-4 py-3 text-sm text-foreground"] : []),
    ...(kycPermission ? ["px-4 py-3 text-sm text-foreground"] : []),
    ...(kycPermission ? ["px-4 py-3 text-sm text-foreground"] : []),
    ...(kycPermission ? ["px-4 py-3 text-sm text-foreground"] : []),
    "px-4 py-3 text-sm",
    "px-4 py-3 text-sm text-foreground",
    "px-4 py-3 text-sm",
    "px-4 py-3 text-sm space-y-1",
  ];
  const { visibleIndices, allColumns, toggleVisibility, reorder, resetToDefault } =
    useColumnPreferences(storageKey, headers);

  return docs?.data ? (
    <div className="relative rounded-lg border bg-muted/30 overflow-x-auto">
      <TableToolbar
        columns={allColumns}
        onToggle={toggleVisibility}
        onReorder={reorder}
        onReset={resetToDefault}
      />
      <table className="w-full">
        <thead>
          <tr className="border-b bg-muted/50">
            {visibleIndices.map((origIdx) => (
              <th key={origIdx} className="px-4 py-3 text-left text-sm font-semibold text-foreground">{headers[origIdx]}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {docs.data != undefined &&
            Object.keys(docs.data).length > 0 &&
            docs?.data?.length > 0 ? (
            docs.data.map((item, index) => {
              return (
                <tr key={index} className="border-b hover:bg-muted/20 transition-colors">
                  {visibleIndices.map((origIdx) => (
                    <td key={origIdx} className={cellClassName[origIdx]}>
                      {rowAccessors[origIdx](item)}
                    </td>
                  ))}
                </tr>
              );
            })
          ) : (
            <tr className="border-b">
              <td colSpan={visibleIndices.length} className="px-4 py-8 text-center text-sm text-muted-foreground">
                {KYC_CONSTANTS.nokycDocfound}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  ) : (
    <div className="py-8 text-center text-sm text-muted-foreground">
      {KYC_CONSTANTS.nokycDocfound}
    </div>
  );
};

export const Kyc = (props) => {
  const [imagePopUp, setImagePopUp] = useState("");
  const [urlPopup, setUrlPopUp] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const dispatch = useDispatch();
  const [kycID, setKycID] = useState("");
  const [declineBox, setDeclineBox] = useState(false)

  const handleActive = (status) => {
    const userId = localStorage.getItem("userId");
    dispatch(verifyKyc(kycID, status));
    setTimeout(() => {
      dispatch(getPlayer({ user_id: userId }));
    }, 500);
    props.setKycdialog(false);
    setImagePopUp("");
    setUrlPopUp("");
  };
  useEffect(() => {
    let mounting = true;
    const userId = localStorage.getItem("userId");
    if (mounting) {
      if (props.kycdialog) {
        if (props.kycType.length > 0) {
          for (let i in props.kycType) {
            let kycdata = {
              kycType: props.kycType[i],
              //status: "SUBMITTED",
            };
            props.dispatch(
              getKycDoc(
                userId,
                props.paginationFirstValue - 1,
                props.paginationSecondValue,
                kycdata
              )
            );
          }
        }
      }
    }

    return () => mounting = false;
  }, [props.kycdialog]);

  const handleClick = (item, type) => {
    setUrlPopUp("IMAGE");
    setImageUrl(item);
  };
  const handlePopUpClose = () => {
    setImagePopUp("");
    setImageUrl("");
    setUrlPopUp("");
  };
  const handleSetKycID = (id, key, status) => {
    setKycID(id);
    setImagePopUp(status);
  };

  const handleReject = (id) => {
    setDeclineBox(true)
    setKycID(id);
  }
  const rejectApiCall = (msg) => {
    dispatch(rejectKyc(msg, kycID, "REJECTED"));
    props.setKycdialog(false);
  }

  return (
    <>
      <Dialog open={declineBox} onOpenChange={setDeclineBox}>
        <DialogContent className="max-w-md max-h-[90vh] overflow-hidden flex flex-col">
          <DialogHeader>
            <DialogTitle>Decline Document</DialogTitle>
          </DialogHeader>
          <div className="flex-1 overflow-y-auto">
            <KycCommentBox
              finish={(msg) => rejectApiCall(msg)}
              close={() => setDeclineBox(false)}
            />
          </div>
        </DialogContent>
      </Dialog>
      <Dialog open={urlPopup === 'IMAGE'} onOpenChange={handlePopUpClose}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-hidden flex flex-col">
          <DialogHeader>
            <DialogTitle>Document Preview</DialogTitle>
          </DialogHeader>
          <div
            className="flex justify-center items-center bg-muted rounded-lg p-4 flex-1 overflow-y-auto"
            style={{
              minHeight: "400px",
              userSelect: "text",
            }}
          >
            {urlPopup == "IMAGE" && <img src={imageUrl} alt="KYC Document" className="max-w-full max-h-full rounded" />}
          </div>
        </DialogContent>
      </Dialog>
      <Dialog open={imagePopUp !== ''} onOpenChange={handlePopUpClose}>
        <DialogContent className="max-w-md max-h-[90vh] overflow-hidden flex flex-col">
          <DialogHeader>
            <DialogTitle className="text-lg font-semibold">
              {imagePopUp == "CONFIRM" ? "Confirm Document Approval" : "Confirm Document Rejection"}
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4 py-4 flex-1 overflow-y-auto">
            <p className="text-sm text-muted-foreground leading-relaxed">
              {imagePopUp == "CONFIRM" 
                ? "Are you sure you want to approve this KYC document? This action cannot be undone."
                : "Are you sure you want to reject this KYC document? Please ensure this is the correct decision."}
            </p>
          </div>
          <div className='flex justify-end gap-3 pt-4 border-t'>
            <Button
              variant="outline"
              onClick={() => handlePopUpClose()}
            >
              {COMMON_CONSTANTS.noBtn}
            </Button>
            <Button
              variant={imagePopUp == "CONFIRM" ? "default" : "destructive"}
              onClick={() => handleActive(imagePopUp == "CONFIRM" ? "KYC_PASSED" : "REJECTED")}
            >
              {imagePopUp == "CONFIRM" ? "Approve" : "Reject"}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      <Dialog open={props.kycdialog} onOpenChange={() => props.setKycdialog(false)}>
        <DialogContent className="w-[60vw] max-w-[60vw] max-h-[90vh] overflow-hidden flex flex-col">
          <DialogHeader>
            <DialogTitle className="text-lg font-semibold">KYC Verification</DialogTitle>
          </DialogHeader>
          <div className="space-y-6 overflow-y-auto flex-1 pr-4">
            {/* Identity Documents Section */}
              <div className='border-b pb-3'>
                <h3 className='text-sm font-medium text-foreground'>{KYC_CONSTANTS.identity_docs}</h3>
              </div>
              <KycDocsTable
                docs={props.identityDocs}
                kycPermission={props.kycPermission}
                storageKey="primaryplayerKycIdentityDocs"
                onView={(docPath) => handleClick(docPath)}
                onConfirm={(id) => handleSetKycID(id, "KYC_PASSED", "CONFIRM")}
                onReject={(id) => handleReject(id)}
              />

            {/* Address Documents Section */}
              <div className='border-b pb-3'>
                <h3 className='text-sm font-medium text-foreground'>{KYC_CONSTANTS.address_docs}</h3>
              </div>
              <KycDocsTable
                docs={props.addressDocs}
                kycPermission={props.kycPermission}
                storageKey="primaryplayerKycAddressDocs"
                onView={(docPath) => handleClick(docPath)}
                onConfirm={(id) => handleSetKycID(id, "KYC_PASSED", "CONFIRM")}
                onReject={(id) => handleReject(id)}
              />

            {/* Source of Funds Documents Section */}
              <div className='border-b pb-3'>
                <h3 className='text-sm font-medium text-foreground'>{KYC_CONSTANTS.source_of_funds_docs}</h3>
              </div>
              <KycDocsTable
                docs={props.sourceOfFundsDocs}
                kycPermission={props.kycPermission}
                storageKey="primaryplayerKycSourceOfFundsDocs"
                onView={(docPath) => handleClick(docPath)}
                onConfirm={(id) => handleSetKycID(id, "KYC_PASSED", "CONFIRM")}
                onReject={(id) => handleReject(id)}
              />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    userId: state.playersearch.userId,
    kycData: state.primaryplayer.kycData,
    kycType: state.primaryplayer.kycType,
    kycDoc: state.primaryplayer.kycDoc,
    kycDocAdd: state.primaryplayer.kycDocAdd,
    identityDocs: state.primaryplayer.identityDocs,
    addressDocs: state.primaryplayer.addressDocs,
    sourceOfFundsDocs: state.primaryplayer.sourceOfFundsDocs,
    paginationFirstValue: state.playersearch.paginationFirstValue,
    paginationSecondValue: state.playersearch.paginationSecondValue,
    kycPermission: state.dashboard.kycPermission,
  };
};
export default connect(mapStateToProps)(Kyc);